import { atom } from 'jotai';
import cuid from 'cuid';

const listLoadCustomerAtom = atom<string>(cuid());
const detailCustomerAtom = atom<{
  show: boolean;
  customer_id: string;
  info: {
    name: string;
    email: string;
  };
}>({
  show: false,
  customer_id: '',
  info: {
    name: '',
    email: '',
  },
});

export { listLoadCustomerAtom, detailCustomerAtom };
